import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';

import type { TFormDraftFirstStep, IDeps } from './models';
import { FormDraftFirstStep as Component } from './component';

export const FormDraftFirstStep = createWidgetWithErrorBoundary<IDeps, TFormDraftFirstStep>({})(
    Component
);
